import * as React from 'react';

export const ExampleManifests = () => (
    <>
        You can find manifests{' '}
        <a href='https://github.com/argoproj/argo-workflows/tree/main/examples' target='_blank' rel='noreferrer'>
            in the examples
        </a>{' '}
        or templates in{' '}
        <a href='https://argoproj-labs.github.io/argo-workflows-catalog/' target='_blank' rel='noreferrer'>
            Workflow Template Catalog
        </a>
    </>
);
